import React from 'react';
import { Box, ProfileInformationIcon } from '@common-fe/common-fe';

import { BlockWrapper } from '@/modules/ExpressSetup/ExpressSetupSignUp/components';

import AccountDetailsForm from './AccountDetailsForm';
import SecurityForm from './SecurityForm';

const MainContactAccess = () => {
  return (
    <BlockWrapper Icon={ProfileInformationIcon} title="Main Contact Access">
      <Box>
        <AccountDetailsForm />
      </Box>
      <Box margin={{ top: 'spacing24' }}>
        <SecurityForm />  
      </Box>
    </BlockWrapper>
  );
};

export default MainContactAccess;
